import { createSelector } from 'reselect';

import { VersionReason } from '../../../../shared/enums';

const selectAllVersions = state => state.versions.items || [];

const selectVersionByProjectId = projectId => createSelector(
  selectAllVersions,
  versions => versions.find(version => version.projectId === projectId) || {},
);

const selectVersionsByChapterId = createSelector(
  selectAllVersions,
  (state, chapterId) => chapterId,
  (versions, chapterId) => versions.filter(version => version.chapterId === chapterId),
);

const selectMajorVersions = createSelector(
  selectAllVersions,
  (versions) => {
    const majorVersionReasons = Object.values(VersionReason).reduce((acc, value) => {
      if (value !== VersionReason.DRAFT_UPDATED) {
        acc.push(value);
      }
      return acc;
    }, []);
    return versions.filter(version => majorVersionReasons.includes(version.reason));
  },
);

const selectMajorAndChapterVersions = createSelector(
  selectMajorVersions,
  selectVersionsByChapterId,
  (state, chapterId) => chapterId,
  (majorVersions, chapterVersions, chapterId) => chapterVersions.concat(majorVersions.filter(version => version.chapterId !== chapterId)),
);

const selectRequestStatus = state => state.versions.status;

const shouldCreateVersion = state => state.versions.shouldCreateVersion;

export default {
  selectAllVersions,
  selectRequestStatus,
  selectVersionByProjectId,
  selectVersionsByChapterId,
  shouldCreateVersion,
  selectMajorAndChapterVersions,
};
